import * as React from 'react';

export const Wrapper:React.FunctionComponent = (props:any) => {
    return props.children;
}